import { useState } from 'react'
import { useSuspenseQuery } from '@w/react-query'
import { Select, SelectTrigger, SelectValue, SelectPopup, SelectItem } from '@w/ui/components/select'
import { useRouterContext } from '../router/flashcards-fe.router-bindings'
import { personName, type PersonMember } from './person'

export function PersonCell({ workspaceId, value, disabled, testId, label, save }: {
  workspaceId: string; value: unknown; disabled: boolean; testId: string; label: string; save: (value: unknown) => Promise<void>
}) {
  const ctx = useRouterContext()
  const { data: directory } = useSuspenseQuery(ctx.rpc.workspace.list.queryOptions(), ctx.queryClient)
  const members = directory.memberships.filter(member => member.workspaceId === workspaceId)
  const selected = typeof value === 'string' ? value : null
  const member = members.find(member => member.userId === selected)
  const [error, setError] = useState<string | null>(null)
  async function commit(next: string | null) {
    try { await save(next === '' ? null : next); setError(null) }
    catch (cause) { setError(cause instanceof Error ? cause.message : String(cause)) }
  }
  return <div><Select value={selected} disabled={disabled} onValueChange={next => { void commit(next) }}>
    <SelectTrigger aria-label={label} data-testid={testId}><SelectValue placeholder="Empty">
      {selected ? member ? <MemberLabel member={member} avatarTestId={`${testId}-avatar`} /> : 'Former member' : null}
    </SelectValue></SelectTrigger>
    <SelectPopup>
      <SelectItem value="" data-testid={`${testId}-clear`}>Empty</SelectItem>
      {selected && !member ? <SelectItem value={selected} disabled>Former member</SelectItem> : null}
      {members.map(member => <SelectItem key={member.userId} value={member.userId} data-testid={`${testId}-member-${member.userId}`}><MemberLabel member={member} /></SelectItem>)}
    </SelectPopup>
  </Select>{error ? <p role="alert">{error}</p> : null}</div>
}

function MemberLabel({ member, avatarTestId }: { member: PersonMember; avatarTestId?: string }) {
  return <span className="inline-flex items-center gap-2">{member.avatar ? <img data-testid={avatarTestId} src={member.avatar} alt="" className="size-5 rounded-full object-cover" /> : null}<span>{personName(member)}</span></span>
}
